<template>
  <div class="radiolist">
    <div
      class="radiolist__toggle"
      aria-haspopup="true"
      :aria-expanded="isOpen"
      @click.prevent="isOpen = !isOpen"
    >
      <slot name="trigger"></slot>
    </div>

    <div
      v-show="isOpen"
      class="radiolist__menu bs--booking-tool"
      :class="classes"
      :style="{ width }"
    >
      <div class="pv3 ph4 ph5-l bg-white tc">
        <p class="f-smallest fw5 ttu mb3-l">{{ translations.selectLocation }}</p>

        <div class="mb3-l">
          <ul class="list tl">
            <li v-for="option in locationOptions" :key="option.hotel" class="mb1">
              <div class="radio">
                <input
                  @input="onInput"
                  type="radio"
                  name="locationOption"
                  :value="option.hotel"
                  :id="option.hotel"
                />
                <label :for="option.hotel" class="flex items-center">{{ option.locationName }}</label>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import s from "../store.js"

export default {
  name: "RadioList",

  data() {
    return {
      sharedState: s.state,
      options: this.locationOptions,
      isOpen: false
    }
  },

  props: {
    translations: { type: Object },
    locationOptions: { type: Array },
    width: { default: "auto" },
    classes: { default: "right-0" }
  },

  created() {
    if (s.debug)
      console.log("Created RadioList component with:", this.locationOptions)
  },

  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeIfClickedOutside)
      }
    }
  },

  methods: {
    onInput: function(location) {
      if (s.debug) {
        console.log("onInput RadioList", location.target.value)
      }
      this.sharedState.activeHotel = location.target.value
      this.sharedState.errorBookingHotel = false

      s.setBookingScriptSettings(location.target.value)
    },

    closeIfClickedOutside(event) {
      if (!event.target.closest(".radiolist")) {
        this.isOpen = false
        document.removeEventListener("click", this.closeIfClickedOutside)
      }
    }
  }
}
</script>

<style scoped>
.radiolist {
  position: relative;
}

.radiolist__menu {
  position: absolute;
  z-index: 100;
  bottom: 6rem;
}

.radiolist__menu::after {
  content: "";
  top: 100%;
  right: 10%;
  border: solid transparent;
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-top-color: #fff5e4;
  border-width: 9px;
  margin-left: -9px;
}

.book-tool__popout .radiolist__menu::after {
  border-color: rgba(255, 255, 255, 0);
  border-top-color: #fff;
}
</style>
